let _ = t => t,
  _t;
import { GYPSUM, KOALA, OLAF } from 'HubStyleTokens/colors';
import styled, { css } from 'styled-components';
import breakpoint from '../../../constants/Breakpoints';
export const TableContainer = styled.div.withConfig({
  displayName: "SuiteFeatureTableComponents__TableContainer",
  componentId: "sc-1dy0nry-0"
})(["width:100%;table{width:100%;border-spacing:0;table-layout:fixed;}table thead tr th:nth-child(1),table tbody tr th:nth-child(1){width:", ";border:1px solid ", ";}"], ({
  columns
}) => columns < 3 ? '50%' : '30%', KOALA);
export const paddingLeft = css(["padding-left:42px;", ""], breakpoint.tablet(_t || (_t = _`
    padding-left: 16px;
    `)));
export const rowHeaderStyles = css(["text-align:left;", ""], paddingLeft);
export const Table = styled.table.withConfig({
  displayName: "SuiteFeatureTableComponents__Table",
  componentId: "sc-1dy0nry-1"
})(["tbody tr{display:table;width:100%;table-layout:fixed;min-height:70px;}"]);
export const ExpandableSectionLabel = styled.tbody.withConfig({
  displayName: "SuiteFeatureTableComponents__ExpandableSectionLabel",
  componentId: "sc-1dy0nry-2"
})(["background-color:", ";tr td:nth-child(1) div > div{width:100%;text-align:left;padding-top:8px;padding-bottom:8px;", " display:flex;align-items:flex-end;}"], GYPSUM, paddingLeft);
export const ExpandableTableContent = styled.tbody.withConfig({
  displayName: "SuiteFeatureTableComponents__ExpandableTableContent",
  componentId: "sc-1dy0nry-3"
})(["position:relative;overflow:hidden;display:block;max-height:", ";transition:max-height 0.2s linear;&::after{visibility:", ";opacity:", ";position:absolute;left:0;bottom:0;height:100%;width:100%;content:'';background:linear-gradient(to bottom,transparent 70%,", ");pointer-events:none;}& tr td{padding:16px 0;text-align:center;border:1px solid ", ";}& tr th[scope='row']{", "}"], props => props.isSectionExpanded ? props.isFeatureTableExpanded ? '100%' : '350px' : '0', props => props.isFeatureTableExpanded ? 'hidden' : 'visible', props => props.isFeatureTableExpanded ? 0 : 1, OLAF, KOALA, rowHeaderStyles);
export const ExpandTableButtonContainer = styled.tbody.withConfig({
  displayName: "SuiteFeatureTableComponents__ExpandTableButtonContainer",
  componentId: "sc-1dy0nry-4"
})(["& tr td{padding-bottom:24px;", "}"], paddingLeft);